import { Request } from '../../Servidor/Request';

export class LocalityNameRequest {
    private sgepnomelocalidade: number;
    private codigo: string;
    private sgepbairros: number;
    private sgepdistrito: number;

    constructor(sgepnomelocalidade: number, codigo: string, sgepbairros: number, sgepdistrito: number) {
        this.sgepnomelocalidade = sgepnomelocalidade;
        this.codigo = codigo;
        this.sgepbairros = sgepbairros;
        this.sgepdistrito = sgepdistrito;
    }


    /**
     * Getter sgepnomelocalidade
     * @return {number}
     */
    public getSgepNomeLocalidade(): number {
        return this.sgepnomelocalidade;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getCodigo(): string {
        return this.codigo;
    }
}

export class LocalityNameStructRequest {
    private sgepnomelocalidade: number;

    constructor(sgepnomelocalidade: number) {
        this.sgepnomelocalidade = sgepnomelocalidade;
    }


    /**
     * Getter sgepnomelocalidade
     * @return {number}
     */
    public getSgepNomeLocalidade(): number {
        return this.sgepnomelocalidade;
    }

}

export class LocalityNameStructResponse {
    private sgepnomelocalidade: number;
    private codigo: string;

    constructor(sgepnomelocalidade: number, codigo: string) {
        this.sgepnomelocalidade = sgepnomelocalidade;
        this.codigo = codigo;
    }


    /**
     * Getter sgepnomelocalidade
     * @return {number}
     */
    public getSgepNomeLocalidade(): number {
        return this.sgepnomelocalidade;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getCodigo(): string {
        return this.codigo;
    }
}

export class LocalityNameInteractor {
    public fetchSave(request: LocalityNameRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/nome-localidade/salvar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: LocalityNameStructRequest): PromiseLike<LocalityNameStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/nome-localidade/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}